import { CARD_STATUS } from '#client/constants/cards';

export const ENABLE_REQUEST_CARD_STATUS = [CARD_STATUS.ACTIVE, CARD_STATUS.FROZEN];
export const DISABLE_FREEZE_CARD_STATUS = [
  CARD_STATUS.INACTIVE,
  CARD_STATUS.FROZEN,
  CARD_STATUS.SUSPECTED_FRAUD
];
